// extracted by mini-css-extract-plugin
export default {"menu":"styles_menu__ySrtB","menuItem":"styles_menuItem__ZMl0S"};